import { ReduceStore } from 'flux/utils';
import Dispatcher from './Dispatcher';
import Constants from './Constants';

class LanguageStore extends ReduceStore {
  constructor() {
    super(Dispatcher);
  }

  getInitialState() {
    return 'en';
  }

  reduce(state, action) {
    switch (action.actionType) {
      case Constants.APP_CHANGE_LANGUAGE:
        return action.language;

      default:
        return state;
    }
  }
}

export default new LanguageStore();



// WEBPACK FOOTER //
// ./src/flux/LanguageStore.js